import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pdfacture/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/pdfacture/src/components/animations/AnimatedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginButton"] */ "/var/www/pdfacture/src/components/auth/LoginButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/var/www/pdfacture/src/components/profile/LogoutButton.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/pdfacture/src/components/profile/preferences/Preferences.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserBox"] */ "/var/www/pdfacture/src/components/profile/UserBox.tsx");
